// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0a2833c9","239":"550ed72e","455":"52cf0d1c"}[chunkId] + ".chunk.js";
};